import { render } from "./chatHistory.vue?vue&type=template&id=8e237fea"
import script from "./chatHistory.vue?vue&type=script&lang=js"
export * from "./chatHistory.vue?vue&type=script&lang=js"

import "./chatHistory.vue?vue&type=style&index=0&id=8e237fea&lang=scss"
script.render = render

export default script